var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.disabled,"loading":_vm.loading,"plain":_vm.plain,"round":_vm.round,"circle":_vm.circle,"autofocus":_vm.autofocus},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }